export const getYearTranslationKey = (age: number): string => {
  const lastDigit = age % 10
  const lastTwoDigits = age % 100

  if (lastTwoDigits >= 12 && lastTwoDigits <= 14) return 'generic.year_pl_x5_to_x1'
  if (lastDigit === 1) return 'generic.year_pl_x5_to_x1'
  if (lastDigit >= 2 && lastDigit <= 4) return 'generic.year_pl_x2_to_x4'

  return 'generic.year_pl_x5_to_x1'
}
